<template>
    <div class="new-account">
        <v-layout row wrap>
            <v-flex xs12 md12 lg12>
                <v-card>
                    <v-card-title class="primary">
                        <span class="white--text headline font-weight-medium hidden-sm-and-down">
                            О компании
                        </span>
                        <span class="white--text body-2 font-weight-medium hidden-md-and-up">
                            О компании
                        </span>
                    </v-card-title>
                    <v-tabs v-model="active"
                            icons-and-text grow
                            color="bg_navbar"
                            slider-color="primary">
                        <v-tab :key="1" ripple>
                            <span class="secondary--text hidden-sm-and-down">Информация и контакты</span>
                            <v-icon>list_alt</v-icon>
                        </v-tab>
                        <v-tab :key="2" ripple>
                            <span class="secondary--text hidden-sm-and-down">На карте</span>
                            <v-icon>map</v-icon>
                        </v-tab>
                        <v-tab :key="3" ripple>
                            <span class="secondary--text hidden-sm-and-down">Документы</span>
                            <v-icon>work_outline</v-icon>
                        </v-tab>
                        <v-tabs-items touchless>
                            <v-tab-item :key="1">
                                <v-card flat>
                                    <v-card-text>
                                        <v-container grid-list-md>
                                            <v-layout row wrap>
                                                <v-flex xs12 md6>
                                                    <div class="table-container">
                                                        <v-data-table
                                                                :items="company_info" class="elevation-1"
                                                                hide-actions hide-headers
                                                        >
                                                            <template slot="items" slot-scope="props">
                                                                <tr :style="props.item.style">
                                                                    <td class="text-xs-right primary--text">
                                                                        {{props.item.label}}
                                                                    </td>
                                                                    <td class="text-xs-left">
                                                                        <p v-for="txt in props.item.value"
                                                                           v-bind:key="props.item.value.indexOf(txt)"
                                                                           style="margin-bottom: 0px;">
                                                                            {{ txt }}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </v-data-table>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <div class="table-container">
                                                        <v-data-table
                                                                :items="company_other" class="elevation-1"
                                                                hide-actions hide-headers
                                                        >
                                                            <template slot="items" slot-scope="props">
                                                                <tr :style="props.item.style">
                                                                    <td class="text-xs-right accent--text">
                                                                        <v-icon>{{props.item.icon}}</v-icon>
                                                                    </td>
                                                                    <td class="text-xs-right accent--text">
                                                                        {{props.item.label}}
                                                                    </td>
                                                                    <td class="text-xs-left">
                                                                        <p v-for="txt in props.item.value"
                                                                           v-bind:key="props.item.value.indexOf(txt)"
                                                                           style="margin-bottom: 0px;">
                                                                            <a v-if="props.item.type=='mail'"
                                                                               v-bind:href="'mailto:'+txt">{{txt}}</a>
                                                                            <a v-if="props.item.type=='link'"
                                                                               v-bind:href="txt"
                                                                               target="_blank">{{txt}}</a>
                                                                            <span v-if="props.item.type=='text'">{{txt}}</span>
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </v-data-table>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item :key="2">
                                <v-card flat>
                                    <v-card-text>
                                        <v-layout align-center justify-center row fill-height>
                                            <yandex-map
                                                    :coords="ym_coords"
                                                    zoom="12.6"
                                                    style="width: 80vw; height: 80vh;"
                                                    :cluster-options="{1: {clusterDisableClickZoom: true}}"
                                                    :behaviors="['drag']"
                                                    :controls="['rulerControl', 'trafficControl', 'zoomControl', 'fullscreenControl']"
                                            >
                                                <ymap-marker
                                                        marker-id="1"
                                                        marker-type="placemark"
                                                        :coords="ym_coords_main"
                                                        hint-content='ООО "СДТ"'
                                                        :balloon="ym_baloon_main"
                                                        :icon="{color: 'red', glyph: 'Pocket'}"
                                                        cluster-name="1"
                                                ></ymap-marker>
                                                <ymap-marker
                                                        marker-id="2"
                                                        marker-type="placemark"
                                                        :coords="ym_coords_lenta"
                                                        hint-content='Лента'
                                                        :balloon="ym_baloon_lenta"
                                                        :icon="{color: 'blue'}"
                                                        cluster-name="2"
                                                ></ymap-marker>
                                                <ymap-marker
                                                        marker-id="3"
                                                        marker-type="placemark"
                                                        :coords="ym_coords_tgl"
                                                        hint-content='Левобережный'
                                                        :balloon="ym_baloon_tgl"
                                                        :icon="{color: 'blue'}"
                                                        cluster-name="3"
                                                ></ymap-marker>
                                            </yandex-map>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item :key="3">
                                <v-card flat>
                                    <v-card-text>
                                        <v-layout align-start justify-start column fill-height>
                                            <template v-for="doc in documents">
                                                <v-flex v-bind:key="doc.id">
                                                    <v-chip label class="white">
                                                        <v-avatar>
                                                            <v-icon class="secondary--text">{{doc.icon}}</v-icon>
                                                        </v-avatar>
                                                    </v-chip>
                                                    <a v-bind:href="doc.href" target="_blank">{{doc.label}}</a>
                                                </v-flex>
                                            </template>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import { yandexMap, ymapMarker } from 'vue-yandex-maps'
    export default {
        name: "About",
        data(){
            return {
                // Tabs
                active: null,
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
                // Company Info
                company_info: [
                    {id: 0, label: 'Полное наименование', style: '',
                        value: ['Общество с ограниченной ответственностью', 'Сибирский Дом Техники']},
                    {id: 1, label: 'Сокращенное наименование', style: '',
                        value: ['ООО "СДТ"']},
                    {id: 2, label: 'Юридический адрес', style: '',
                        value: ['630088, Новосибирская обл., Новосибирск г., Северный (Кировский р-н) проезд, дом № 7']},
                    {id: 3, label: 'Почтовый адрес', style: '',
                        value: ['630088, г. Новосибирск, а/я 168']},
                    {id: 5, label: 'Директор', style: 'border-bottom: 2px solid #B71C1C',
                        value: ['Дмитриев Игорь Александрович', 'действует на основании Устава']},
                    {id: 6, label: 'ИНН', style: '',
                        value: ['5403315500', 'Свидетельство 54 №004659461 от 26.01.2010 г.']},
                    {id: 7, label: 'КПП', style: '',
                        value: ['540301001']},
                    {id: 8, label: 'ОГРН', style: '',
                        value: ['1105403000339', 'Свидетельство 54 №004201172 от 26.01.2010 г.']},
                    {id: 9, label: 'ОКПО', style: '',
                        value: ['64360256']},
                    {id: 10, label: 'ОКВЭД осн.', style: '',
                        value: ['46.43']},
                    {id: 11, label: 'ОКВЭД доп.', style: 'border-bottom: 2px solid #B71C1C',
                        value: ['46.41, 46.44, 46.49, 46.90, 47.51, 47.54, 47.77.1, 47.99']},
                    {id: 13, label: 'Расчетный счет',
                        value: ['40702810200600000835', 'в АО "СМП БАНК"']},
                    {id: 14, label: 'Кор. счет', style: '',
                        value: ['30101810545250000503']},
                    {id: 15, label: 'БИК Банка', style: '',
                        value: ['044525503']},
                ],
                company_other: [
                    {id: 1, label: 'Режим работы', icon: 'access_time', style: '', type: 'text',
                        value: ['С 9:00 до 18:00 (МСК+4) с пн. по пт.']},
                    {id: 2, label: 'Телефон', icon: 'phone', style: '', type: 'text',
                        value: ['+7 (383) 210-54-30']},
                    {id: 3, label: 'Факс', icon: 'phone', style: '', type: 'text',
                        value: ['+7 (383) 210-54-31', '+7 (383) 210-54-30, доб.: 9']},
                    {id: 4, label: 'E-mail', icon: 'mail', style: 'border-bottom: 2px solid #006dff', type: 'mail',
                        value: ['mail@sibdt.com']},
                    {id: 5, label: 'ЭДО', icon: 'cloud', style: '', type: 'text',
                        value: ['СКБ Контур.Диадок', 'ООО Компания "Тензор"']},
                    {id: 6, label: 'EDI', icon: 'cloud', style: '', type: 'text',
                        value: ['СКБ Контур.EDI']},
                    {id: 7, label: 'GLN', icon: 'public', style: 'border-bottom: 2px solid #006dff', type: 'text',
                        value: ['4607966289997']},
                    {id: 8, label: 'Для розничных клиентов (партнер)', icon: 'shopping_basket', style: '', type: 'link',
                        value: ['https://sibdt.com']},
                ],
                // Yandex Map
                ym_coords: [54.951324, 82.896748],
                ym_coords_main: [54.949538, 82.926075],
                ym_coords_lenta: [54.940714, 82.923033],
                ym_coords_tgl: [54.950856, 82.899609],
                ym_baloon_main: {header: 'ООО "СДТ"', body: 'Северный проезд, 7', footer: '+7 (383) 210-54-30'},
                ym_baloon_lenta: {header: 'Лента', body: 'ул. Петухова, 73'},
                ym_baloon_tgl: {header: 'ТГ Левобережный', body: 'Левобережный рынок'},
                // documents
                documents: [
                    { id: 1, label: 'Карточка организации', href: '/content/documents/card.pdf', icon: 'insert_drive_file', },
                    { id: 2, label: 'Свидетельство о постановке на учет в налоговом органе (ИНН)', href: '/content/documents/inn.pdf', icon: 'insert_drive_file', },
                    { id: 3, label: 'Свидетельство о внесении записи в ЕГРЮЛ (ОГРН)', href: '/content/documents/ogrn.pdf', icon: 'insert_drive_file', },
                    { id: 4, label: 'Устав ООО "СДТ" от 11.08.2012 г.', href: '/content/documents/ustav_ 2012.11.08.pdf', icon: 'insert_drive_file', },
                    { id: 5, label: 'Приказ о назначении директора от 29.03.2016 г.', href: '/content/documents/order_director.pdf', icon: 'insert_drive_file', },
                ],
            }
        },
        components: {
            yandexMap,
            ymapMarker,
        },
        methods: {
            // Form MISC
            show_snack(snack_color, snack_text) {
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
        },
    }
</script>

<style scoped>
</style>